import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import {get} from 'lodash';

export default class RowItemDSTongHopKHTTDonVi extends Component {
  render() {
    const data = this.props.item;
    const {namThanhTra, ngayRaQuyetDinh, quyetDinhPheDuyetKTTT, keHoachThanhTraId} = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <Link className='txt-underline txt-regular' to={`/thanh-tra/ke-hoach-thanh-tra/chi-tiet/${keHoachThanhTraId}`}>
            {`Kế hoạch ${get(data, 'loaiKeHoach.value')=== 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra' } năm ${namThanhTra}`}
          </Link>
        </td>
        <td>
          {quyetDinhPheDuyetKTTT || ''}
        </td>
        <td>{ngayRaQuyetDinh ? moment(ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}</td>
        <td>{get(data, 'donViInfo.ten')}</td>
        <td>{get(data, 'soCuocThanhTra')}</td>
        <td>{get(data, 'loaiKeHoach.value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'}</td>
        <td>{get(data, 'trangThaiKeHoachThanhTraInfo.text')}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemDSTongHopKHTTDonVi.jsx